import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';
import testimonies from '../data/testimonies';

const TestimonyDetail = () => {
  const { slug } = useParams();
  const testimony = testimonies.find(t => t.slug === slug);

  if (!testimony) {
    return <Navigate to="/testimonies" replace />;
  }

  return (
    <>
      <SEOHead path="/testimonies" />
      <PageHeader title={testimony.name} breadcrumb={`Testimony / ${testimony.name}`} />

      <section className="section">
        <div className="container">
          <div className="testimony-detail fade-in">
            <Link to="/testimonies" className="back-link">← Back to Testimonies</Link>

            <div className="testimony-detail-hero">
              <img src={testimony.image} alt={testimony.name} />
            </div>

            <div className="content-body">
              {testimony.content.map((paragraph, i) => {
                const img = testimony.images[i];

                if (img && img.src) {
                  const isRight = img.position === 'float-right';
                  return (
                    <div
                      key={i}
                      className={`testimony-block testimony-block-with-image ${isRight ? 'image-right' : ''}`}
                    >
                      <img src={img.src} alt={testimony.name} loading="lazy" />
                      <div>
                        <p>{paragraph}</p>
                      </div>
                    </div>
                  );
                }

                return (
                  <div key={i} className="testimony-block testimony-block-text-only">
                    <p>{paragraph}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonyDetail;
